module.exports = __webpack_public_path__ + "img/shop_logo.d266b544.png";